export * from './factory';
export const keyed =
  key =>
    actionCreator =>
      (...args) => ({
        ...actionCreator(...args),
        key,
      });
